import { create } from "zustand";

/** Focus mode (Ctrl/⌘ + .): hides the sidebar and header so only the conversation is left. Not persisted. */
export const useFocus = create<{ on: boolean; toggle: () => void; off: () => void }>((set) => ({
  on: false,
  toggle: () => set((s) => ({ on: !s.on })),
  off: () => set({ on: false }),
}));
